import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import { NavLink, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

//#region Interfaces ... 
interface ILinkTabProps {
    text?: string;
    href?: string;
    type?: string;
}
//#endregion

//#region Styles Components ... 
const TaskTabs = styled(Tabs)({
    color: '#333333',
    position: 'relative',
    '& .MuiTabs-indicator': {
        color: '#001A69',
        backgroundColor: '#001A69',
        height: '3px',
        borderRadius: '4px',
    }
});

const TabLinkStyled = styled(NavLink)(({ theme }) => ({
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '10px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#333333',
    textTransform: 'uppercase',
    textDecoration: 'none',

    '&.active': {
        color: theme.palette.secondary.main,
        fontWeight: 600
    }
}));
//#endregion 

const TabLink = (props: ILinkTabProps) => (
    <TabLinkStyled end to={props.href || ""}>{props.text}</TabLinkStyled>
)

const LinkTab = (props: ILinkTabProps) => (
    <Tab
        component={TabLink}
        {...props}
    />
)

const tabs = [
    {
        text: 'Tasks',
        path: '/task'
    },
    {
        text: 'Work Items',
        path: '/work-item'
    },
];

const TabsHeader = (props: ILinkTabProps) => {
    const location = useLocation();
    const selectedTab = tabs.findIndex(t => location.pathname.includes(t.path));

    const evalPath = (path: string) => {        
        return `${props.type ? props.type: 'team/my'}${path}`
    }

    return (
        <Box sx={{ width: '100%', mb: '25px' }}>
            <TaskTabs value={selectedTab} aria-label="teams tabs">
                {tabs.map((tab, Index) => (<LinkTab text={tab.text} href={`/${evalPath(tab.path)}`} />))}
            </TaskTabs>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: '-2px' }}></Box>
        </Box>
    )
}

export default TabsHeader;